export default __webpack_public_path__ + "assets/images/19a7cc889d6c49fbd23521e5996084ed.svg";